import { useState } from 'react';
import ticketService from '../../ticket-service';

const useTicketForm = ({ onSubmit = () => {} }) => {
  const [showErrors, setShowErrors] = useState(false);
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const [backendErrors, setBackendErrors] = useState({});

  const beforeOnSubmit = () => {
    return (values) => {
      //   clean backend errors
      setBackendErrors({});
      // waiting for backend
      setIsWaitingForResponse(true);
      //   trasnform the values we get from form to the format expected in backend
      const formValues = ticketService.utils.deepCopy(values);
      const dto = ticketService.dataTransformation.getTicketDtoFromFormValues({
        values: formValues,
      });

      onSubmit({ ticketDto: dto })
        //   if submit works, form does nothing
        .then(() => {})
        // if submit fails, form saves the error
        // the original submit could also do something after errors
        .catch((e) => {
          //   the backend will return an error body with json format
          try {
            e.response.json().then((errorBody) => {
              console.error('🔥 ~ errorBody:', errorBody);
              setBackendErrors(errorBody);
            });
          } catch (eee) {
            // if the backend error is not a json, is empty or something unexpected
            // we treat that as a different errors
            setBackendErrors({
              details: 'can_not_reach_backend',
            });
          }
        })
        // whatever happened, is not loading anymore
        .finally(() => {
          setIsWaitingForResponse(false);
        });
    };
  };

  return {
    showErrors,
    setShowErrors,
    isWaitingForResponse,
    setIsWaitingForResponse,
    backendErrors,
    setBackendErrors,
    beforeOnSubmit,
  };
};

export default useTicketForm;
